import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseClasses } from '@/api/responses/manage/academyClasses'

export namespace AcademyClassesApi {
  /**
   * クラス一覧取得(全件)
   *
   * @param academyCourseId コースID
   * @returns クラス一覧
   */
  export async function getAll(academyCourseId: number): Promise<ApiResponseClasses> {
    const params = { academyCourseId: academyCourseId }
    return await ApiBase.get('/manage/academyClasses/all', params)
  }

  /**
   * 引数の型
   */
  type OptionParams = {
    /** コースID */
    academyCourseId: number
    /** 学年コード */
    gradeCode?: string
    /** 教室ID */
    branchId?: number
  }

  /**
   * 生徒が存在するクラス一覧取得
   *
   * @param options コースID(必須)、学年コード(非必須)、教室ID(非必須)
   * @returns クラス一覧
   */
  export async function getClassesHasStudents(options: OptionParams): Promise<ApiResponseClasses> {
    const params = {
      academyCourseId: options.academyCourseId,
      gradeCode: options.gradeCode,
      branchId: options.branchId,
    }
    return await ApiBase.get('/manage/academyClasses', params)
  }

  /**
   * 仮生徒が存在するクラス一覧取得
   *
   * @param options コースID(必須)、学年コード(非必須)、教室ID(非必須)
   * @returns クラス一覧
   */
  export async function getClassesHasTemporaryStudents(options: OptionParams): Promise<ApiResponseClasses> {
    const params = {
      academyCourseId: options.academyCourseId,
      gradeCode: options.gradeCode,
      branchId: options.branchId,
    }
    return await ApiBase.get('/manage/academyClasses/temporary', params)
  }
}
